import React, { useState } from 'react';

/**
 * FAQ-style tuning philosophy accordion.
 * - `marketing`: MarketingPages.css (`philo-*`, light cards).
 * - `guide`: TuningGuidePage.css (`tg-tphilo-*`, dark in-app page).
 */
function TuningPhilosophyContent({ intro, categories, variant = 'marketing' }) {
  const [openCategory, setOpenCategory] = useState(null);
  const [openQuestion, setOpenQuestion] = useState({});

  const isGuide = variant === 'guide';
  const p = (base) => (isGuide ? `tg-tphilo-${base}` : `philo-${base}`);

  const toggleCategory = (id) => {
    setOpenCategory((prev) => (prev === id ? null : id));
    setOpenQuestion({});
  };

  const toggleQuestion = (catId, qid) => {
    const key = `${catId}:${qid}`;
    setOpenQuestion((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const introCardClass = isGuide ? 'tg-tphilo-intro-card' : 'marketing-card philo-intro';
  const rootClass = isGuide ? 'tuning-guide-philo-inner' : '';

  return (
    <div className={rootClass}>
      <div className={introCardClass}>
        <h2>{intro.title}</h2>
        <p>{intro.body}</p>
      </div>

      {categories.map((cat) => {
        const isOpen = openCategory === cat.id;
        return (
          <div key={cat.id} className={p('category')}>
            <button type="button" className={p('cat-btn')} onClick={() => toggleCategory(cat.id)}>
              <span>
                {cat.title}
                {isGuide ? (
                  <span className={p('cat-blurb')}>{cat.blurb}</span>
                ) : (
                  <span
                    style={{
                      display: 'block',
                      fontWeight: 400,
                      fontSize: '0.88rem',
                      marginTop: '0.35rem',
                      opacity: 0.85,
                    }}
                  >
                    {cat.blurb}
                  </span>
                )}
              </span>
              <span className={p('chevron')}>{isOpen ? '▾' : '▸'}</span>
            </button>
            {isOpen ? (
              <div className={p('cat-body')}>
                {cat.items.map((item) => {
                  const qKey = `${cat.id}:${item.id}`;
                  const qOpen = !!openQuestion[qKey];
                  return (
                    <div key={item.id} className={p('item')}>
                      <button type="button" className={p('q-btn')} onClick={() => toggleQuestion(cat.id, item.id)}>
                        <span>{item.q}</span>
                        <span className={p('chevron')}>{qOpen ? '▾' : '▸'}</span>
                      </button>
                      {qOpen ? (
                        <div className={p('a')}>
                          <ul>
                            {item.a.map((line, i) => (
                              <li key={i}>{line}</li>
                            ))}
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default TuningPhilosophyContent;
